import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {fetchFile, getDownloadFileLink} from 'api/debtCollectionMonitor';
import styles from './File.module.sass';
import Question from 'components/common/Question';
import DeleteIcon from '@material-ui/icons/Clear';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Tooltip from '@material-ui/core/Tooltip';
import {toDate} from 'data/converter';
import {popupShow} from 'actions/popup';
import uuid from 'uuid/v1';
import CircularProgress from '@material-ui/core/CircularProgress'
import Popup from 'components/common/Popup/Popup';
import axios from 'axios';
import Label from 'components/common/Label';
import ButtonIcon from 'components/common/ButtonIcon';

@connect()
class AttachFiles extends PureComponent {
  state = {
    isDrag: false,
    queue: []
  };

  uploadFile = async (fls) => {
    const { isDrag } = this.state;
    if (isDrag) this.setState({isDrag: false});

    let {onChange, files, dispatch} = this.props;
    if (!files) files = [];

    if (!fls || fls.length <= 0) return;
    let file = fls[0];

    const fileName = file.name;
    const fileSize = file.size;
    if (fileSize >= 524288000) {
      dispatch(popupShow(`Не возможно прикрепить файл. Максимальный размер файла 524 мегабайта. \n${fileName}`, {display: Popup.display.error}));
      return;
    }

    const queueKey = uuid();
    this.setState({queue: (this.state.queue || []).concat([{key: queueKey, name: file.name}])});

    try {
      const fileId = await fetchFile({file}, {axios});
      const fileObject = {id: fileId, name: fileName};

      if (onChange) onChange(files.concat([fileObject]));
    } catch (e) {

      dispatch(popupShow(`Во время загрузки файла произошла ошибка, вы можете попробовать прикрепить его еще раз.\n${fileName}`, {display: Popup.display.error}));
    }

    this.setState({queue: (this.state.queue || []).filter(a => a.key !== queueKey)});
  };


  //измениен прикрепленного файла
  handlerOnFileChange = async (e) => {
    let files = {...e.target.files};

    if (this.inputFileRef) {
      this.inputFileRef.value = '';
    }

    //если файл не выбран
    await this.uploadFile(files);
  };

  handlerOnDelete =  async (file) => {
    const {onChange} = this.props;
    const {files} = this.props;
    let nextFiles = files.filter(a => file !== a);

    if (onChange) onChange(nextFiles);
  };

  inputFileRef;

  getDataTransferItems = (event) => {
    let dataTransferItemsList = [];
    if (event.dataTransfer) {
      const dt = event.dataTransfer;
      if (dt.files && dt.files.length)
        dataTransferItemsList = dt.files;
      else if (dt.items && dt.items.length)
        dataTransferItemsList = dt.items;
    } else if (event.target && event.target.files) {
      dataTransferItemsList = event.target.files;
    }

    return dataTransferItemsList;
  };

  handlerOnDropFile = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    let files = this.getDataTransferItems(e);
    await this.uploadFile(files);
  };

  handlerOnDragOver = (e) => {
    e.stopPropagation();
    e.preventDefault();

    this.handlerOnDragEnter(e);
  };

  handlerOnDragLeave = (e) => {
    console.log('handlerOnDragLeave');
    const { isDrag } = this.state;
    if (isDrag) this.setState({isDrag: false})
  };

  handlerOnDragEnter = (e) => {
    console.log('handlerOnDragEnter');
    const { isDrag } = this.state;
    if (!isDrag) this.setState({isDrag: true})
  };

  render() {
    const {files, className: classBox, onChange, leftMenu, fileLeftMenu, hiddenDraggingBox} = this.props;
    const { isDrag, queue } = this.state;

    if ((!files || files.length <= 0) && (!queue || queue.length <= 0)) {
      if (onChange) {
        return (
          <div className={cx(classBox)}>
            <input ref={(r) => this.inputFileRef = r} type='file' onChange={this.handlerOnFileChange} style={{display: 'none'}}  />
            <div className={cx(styles.contentBox)}>
              <div className={styles.leftMenu}>
                <ButtonIcon tooltip={'Прикрепить файл'} onClick={() => {if (this.inputFileRef) this.inputFileRef.click()}}><AttachFileIcon/></ButtonIcon>
                {leftMenu && leftMenu.map((element) => element)}
              </div>
              {!hiddenDraggingBox &&
              <div
                className={cx(styles.emptyBox, {[styles.isDrag]: isDrag})}
                onClick={() => {if (this.inputFileRef) this.inputFileRef.click()}}

                onDragOver={this.handlerOnDragOver}
                onDragEnter={this.handlerOnDragEnter}
                onDragLeave={this.handlerOnDragLeave}

                onDrop={this.handlerOnDropFile}
              >
                <div>Перетащите файл в область чтобы прикрепить его</div>
              </div>
              }
            </div>
          </div>
        );
      }
    }

    return (
      <div className={cx(classBox)}>
        {onChange && <input ref={(r) => this.inputFileRef = r} type='file' onChange={this.handlerOnFileChange} style={{display: 'none'}}  />}
        <div className={cx(classBox, styles.contentBox)}>
          {onChange &&
          <div className={styles.leftMenu}>
            <ButtonIcon tooltip={'Прикрепить файл'} onClick={() => {if (this.inputFileRef) this.inputFileRef.click()}}><AttachFileIcon/></ButtonIcon>
            {leftMenu && leftMenu.map((element) => element)}
          </div>
          }

          <div className={styles.filesBox}>
            {files && files.map(file =>
              <div key={file.id} className={styles.fileRow}>
                <div className={styles.fileBox}>
                  <div className={styles.fileInfoBox}>
                    <a href={getDownloadFileLink(file.id)} download>{file.name}</a>
                  </div>
                  <div className={styles.iconsBox}>
                    {fileLeftMenu && fileLeftMenu.map(element => element)}
                    {onChange && <Question header="Вы уверены что хотите удалить файл?" ok="Удалить" onOk={() => this.handlerOnDelete(file)}>
                      <ButtonIcon tooltip={"Удалить"} tooltipPosition={"right"} className={styles.iconFileBox}><DeleteIcon className={styles.iconFileIcon}/></ButtonIcon>
                    </Question>
                    }
                  </div>
                </div>

                <div className={styles.fileSubInfoBox}>
                  {(file.authorFullName || file.time) &&
                  <div className={styles.fileSubInfo}>
                    {file.authorFullName && <div className={styles.fileInfoAuthor}>{file.authorFullName}</div>}
                    {file.time && <div className={styles.fileInfoTime}>{toDate(file.time)}</div>}
                  </div>
                  }
                  {file.description &&
                  <Label className={styles.fileDescription}>{file.description}</Label>
                  }
                </div>

              </div>
            )}
            {queue && queue.length > 0 && queue.map(file =>
              <div key={file.key} className={styles.fileRow}>

                  <div className={styles.fileBox}>
                    <div className={styles.fileInfoBox}><div><div className={styles.queueFileName}>{file.name}</div></div></div>
                    {!file.error
                    &&
                      <Tooltip title="Загружается" placement="right" >
                        <CircularProgress style={{margin: '0 0 0 20px'}} size={25} thickness={7} />
                      </Tooltip>
                    ||
                      <div>{file.error}</div>
                    }
                  </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

AttachFiles.defaultProps = {
  hiddenDraggingBox: false
};

AttachFiles.propTypes = {
  leftMenu: PropTypes.arrayOf([PropTypes.element]),
  fileLeftMenu: PropTypes.arrayOf([PropTypes.element]),
  hiddenDraggingBox: PropTypes.bool,

  className: PropTypes.string,
  files: PropTypes.arrayOf(PropTypes.objectOf({
    id: PropTypes.string,
    name: PropTypes.string,
    time: PropTypes.string,
    authorFullName: PropTypes.string,
  })),

  onChange: PropTypes.func,
};

export default AttachFiles;


// WEBPACK FOOTER //
// ./src/components/common/AttachFiles/AttachFiles.jsx